import React from 'react';
import { Box, Grid, Paper, Skeleton, Typography } from '@mui/material';
import '../../../styles/report.css';
import RectangleIcon from '@mui/icons-material/Rectangle';
import { selectViewInstanceById } from '../../../reducers/reuseable_vi';
import { useSelector } from 'react-redux';

const PrintStyles = () => (
    <style>
        {`
        @media print {
            .legend-print-table {
                width: 100%;
                border-collapse: collapse;
                table-layout: fixed; /* This forces columns to have equal width */
            }

            .legend-print-td {
                text-align: center;
                vertical-align: middle;
                font-family: 'Times New Roman', Times, serif;
                font-size: 9pt;
                padding: 4px;
                white-space: nowrap;
            }
        }
        `}
    </style>
);

const RYGGLegend = (props) => {
    const { variant, PrintView } = props;
    const viewInstance = useSelector(state => selectViewInstanceById(state, 'ReportLegend'));

    // --- PRINT VIEW ---
    if (PrintView === true) {
        // Defensive check to ensure data exists before trying to render
        const legendData = viewInstance?.LegendsVI?.RYGG;
        if (!legendData || !Array.isArray(legendData) || legendData.length === 0) {
            return null; // Don't render anything in print if there's no data
        }

        return (
            <div>
                <PrintStyles />
                <table className="legend-print-table">
                    <tbody>
                        <tr>
                            {legendData.map((item, index) => (
                                <td key={index} className="legend-print-td">
                                    <RectangleIcon sx={{ color: item.Color, fontSize: '14px', verticalAlign: 'middle', marginRight: '5px' }} />
                                    <span>{item.Label}</span>
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    // --- SCREEN VIEW (Restored to original, working state) ---
    const StandardColors = () => {
        const RYGG = viewInstance?.LegendsVI?.RYGG;
        return (
            <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                {RYGG && RYGG.map((obj, idx) => (
                    <Grid item xs={6} md={3} key={"rygg_" + idx}>
                        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={1}>
                            <Grid item xs="auto">
                                <RectangleIcon fontSize='medium' sx={{ color: obj.Color, display: 'block' }} />
                            </Grid>
                            <Grid item xs>
                                <Typography variant="caption" align="left">{obj.Label}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        );
    };

    const FiveColors = () => {
        const fiveColorData = props.FiveColors || [];
        return (
            <Grid container columns={15} direction="row" alignItems="center" justifyContent="center" spacing={2}>
                {fiveColorData.map((x, i) => (
                    <Grid item xs={12} md={3} key={i}>
                         <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                            <Grid item xs={3} justifyContent="end">
                                <Typography align="right">
                                    <RectangleIcon fontSize='medium' sx={{ color: x.Color }} />
                                </Typography>
                            </Grid>
                            <Grid item xs={9} justifyContent="start">
                                <Typography variant="caption" align="left">{x.Label}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        );
    };

    if (viewInstance && viewInstance?.status === 'success') {
        return (
            <Box px={4}>
                {variant === 'FIVE COLOR' ? <FiveColors /> : <StandardColors />}
            </Box>
        );
    } else {
        return (
            <Paper elevation={1}>
                <Skeleton variant="rectangular" animation="wave" sx={{ paddingTop: "10%" }} height={0} />
            </Paper>
        );
    }
};

export default RYGGLegend;